import React, { Component } from 'react';

import { FixedSizeList as List } from 'react-window';

import { Alignment } from '@philips-emr/tws-constants';
import { bool, func, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames, isFunction, isMobile } from '@philips-emr/tws-utils';

import { NativeSelect, Popover } from '../..';
import phoneNumberData from '../phone-number-data';

import { CountryFlag, CountryItem } from '.';

class CountrySelect extends Component {

  static propTypes = {
    enabled: bool,
    value: string,
    readOnly: bool,
    onChange: func,
  };

  static defaultProps = {
    enabled: true,
  };

  state = {};

  getCountry() {
    const { value } = this.props;

    return phoneNumberData.find(country => country.code === value) || {};
  }

  toggleOpen = () => {
    const { enabled, readOnly } = this.props;

    if (!enabled || readOnly) return;

    this.setState(({ open }) => ({ open: !open }));
  };

  getClassName() {
    const { enabled, readOnly } = this.props;

    return classNames({
      'c-country-select': true,
      'is-disabled': !enabled,
      'is-read-only': readOnly,
    });
  }

  renderNative() {
    const { onChange } = this.props;

    const data = phoneNumberData.map(country => ({
      key: country.code,
      label: msg(country.name),
    }));

    const onNativeChange = ({ value } = {}) => {
      isFunction(onChange) && onChange({ code: value.key });
    };

    return <NativeSelect data={data} onChange={onNativeChange} />;
  }

  renderSelect() {
    const country = this.getCountry();

    return (
      <div className={this.getClassName()} onClick={this.toggleOpen}>
        <CountryFlag country={country.code} />
        <span className="c-country-select__code">
          {country.callingCode ? `+${country.callingCode}` : null}
        </span>
        {isMobile() && this.renderNative()}
      </div>
    );
  }

  renderPopover() {
    const { onChange } = this.props;
    const { open } = this.state;

    const onPopoverItemClick = (e) => {
      this.toggleOpen();
      isFunction(onChange) && onChange(e);
    };

    return (
      <Popover open={open} onClose={this.toggleOpen} showArrow={false} alignment={Alignment.LEFT}>
        {this.renderSelect()}

        <Popover.Content>
          <List height={400} width={380} itemCount={phoneNumberData.length - 1} itemSize={28} >
            {({ index, style }) => (
              <CountryItem onClick={onPopoverItemClick} style={style} {...phoneNumberData[index]} />
            )}
          </List>
        </Popover.Content>
      </Popover>
    );
  }

  render() {
    return isMobile()
      ? this.renderSelect()
      : this.renderPopover();
  }
}

export default CountrySelect;
